import React from "react";
import { useHistory } from "react-router-dom";
import { logout } from "services/auth";
import { removeItem } from "utils/localStorage";

import localStorageKeys from "constants/localStorageKeys";
import routes from "constants/routes";

export const useLogout = () => {
  const history = useHistory();

  const handleLogout = React.useCallback(async () => {
    await logout();
    removeItem(localStorageKeys.userAuthorizations);

    history.replace(routes.SIGN_IN);
  }, [history]);

  return handleLogout;
};
